<template>
  <div :class="$style.page">
    <div :class="$style.page__sidebar" v-if="!salesMaterialsOnly">
      <SearchCoverage v-show="!salesMaterialsOnly" v-model="searchText" />
      <DocumentList />
    </div>
    <div :class="$style.page__content">
      <router-view
        :corporations="corporations"
        :salesMaterials="salesMaterials"
        :searchText="searchText"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import SearchCoverage from './SearchCoverage.vue'
import { useSolicitorCloudPageQuery } from './SolicitorCloudPage.generated'
import { computed, ref } from 'vue'
import DocumentList from './DocumentList.vue'
import { useRouter } from 'vue-router'

const { result, onResult } = useSolicitorCloudPageQuery()

const router = useRouter()
onResult(queryResult => {
  if (
    queryResult.loading ||
    queryResult.error != null ||
    queryResult.data.solicitorCloudCorporations.length > 0
  ) {
    return
  }

  // eslint-disable-next-line fp/no-mutating-methods
  router.push({ name: 'solicitorCloudDocumentsSalesMaterial' })
})

const searchText = ref('')

const corporations = computed(
  () => result.value?.solicitorCloudCorporations ?? []
)

const salesMaterialsOnly = computed(() => corporations.value.length === 0)

const salesMaterials = computed(
  () => result.value?.solicitorCloudSalesMaterials ?? []
)
</script>

<style lang="scss" module>
.page {
  display: flex;
  justify-content: center;

  &__sidebar {
    max-width: 300px;

    & > *:nth-child(n + 2) {
      margin-top: 20px;
    }
  }

  &__content {
    width: 100%;
    max-width: 1020px;
    margin-left: 40px;
  }
}
</style>
